var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('span',[_vm._v("Copyright © "),(_vm.isshow_icp)?_c('a',{staticClass:"icp-link",attrs:{"href":"http://beian.miit.gov.cn","target":"_blank"}},[_vm._v(_vm._s(_vm.isshow_icp))]):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" All Rights Reserved.")]),_vm._v(" "),_c('span')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-987f9aba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 